/**
 * Taxonomia tipurilor de facturi eMAG Marketplace (cod -> denumire + grup).
 * Sursă: doc oficial eMAG „Tipuri facturi eMAG Marketplace" (vezi docs/emag-invoice-types.md).
 * Codul e stocat în emag_supplier_invoices.category.
 */
export type EmagInvoiceGroup =
  | 'Comision'
  | 'Vouchere'
  | 'Fulfillment'
  | 'Corecție și penalități'
  | 'eMAG Genius'
  | 'eMAG ADS'
  | 'Transport'
  | 'eMAG Courier'

export interface EmagInvoiceType {
  label: string
  group: EmagInvoiceGroup
}

export const EMAG_INVOICE_TYPES: Record<string, EmagInvoiceType> = {
  // Comision
  FC: { label: 'Comision (comenzi finalizate)', group: 'Comision' },
  FCA: { label: 'Anulare comision', group: 'Comision' },
  FCR: { label: 'Comision comenzi refinalizate', group: 'Comision' },
  FCRA: { label: 'Anulare comision refinalizate', group: 'Comision' },
  FCCO: { label: 'Comision anulate (Card Online)', group: 'Comision' },
  FCCOA: { label: 'Storno comision anulate (Card Online)', group: 'Comision' },
  FCCD: { label: 'Comision anulate (Ramburs)', group: 'Comision' },
  FCCDA: { label: 'Storno comision anulate (Ramburs)', group: 'Comision' },
  FCS: { label: 'Comision comenzi stornate', group: 'Comision' },
  FCSA: { label: 'Anulare comision stornate', group: 'Comision' },
  FCDP: { label: 'Discount de comision', group: 'Comision' },
  FCDPA: { label: 'Anulare discount de comision', group: 'Comision' },
  // Vouchere
  FV: { label: 'Vouchere (decontare)', group: 'Vouchere' },
  FVA: { label: 'Anulare vouchere', group: 'Vouchere' },
  FVS: { label: 'Vouchere stornate', group: 'Vouchere' },
  FVSA: { label: 'Anulare vouchere stornate', group: 'Vouchere' },
  FY: { label: 'Vouchere retur', group: 'Vouchere' },
  FYA: { label: 'Anulare vouchere retur', group: 'Vouchere' },
  // Fulfillment
  FFD: { label: 'Depozitare', group: 'Fulfillment' },
  FFDA: { label: 'Anulare depozitare', group: 'Fulfillment' },
  FFO: { label: 'Procesare comenzi', group: 'Fulfillment' },
  FFOA: { label: 'Anulare procesare comenzi', group: 'Fulfillment' },
  FFX: { label: 'Retragere din fulfillment', group: 'Fulfillment' },
  FFXA: { label: 'Anulare retragere din fulfillment', group: 'Fulfillment' },
  FHR: { label: 'Despăgubire produse deteriorate (FBE)', group: 'Fulfillment' },
  FFR: { label: 'Servicii procesare retur', group: 'Fulfillment' },
  FFT: { label: 'Livrare specială comenzi FBE valoare mică', group: 'Fulfillment' },
  FFTA: { label: 'Anulare livrare specială FBE', group: 'Fulfillment' },
  FFTS: { label: 'Storno livrare specială FBE', group: 'Fulfillment' },
  FFDP: { label: 'Promoție depozitare FBE', group: 'Fulfillment' },
  FFDPA: { label: 'Anulare promoție depozitare FBE', group: 'Fulfillment' },
  FFOP: { label: 'Promoție procesare comenzi FBE', group: 'Fulfillment' },
  FFOPA: { label: 'Anulare promoție procesare comenzi FBE', group: 'Fulfillment' },
  FFSE: { label: 'Servicii suplimentare în depozit', group: 'Fulfillment' },
  FFSEA: { label: 'Anulare servicii suplimentare în depozit', group: 'Fulfillment' },
  FFS: { label: 'Casare produse FBE (scrapping)', group: 'Fulfillment' },
  // Corecție și penalități
  FW: { label: 'Penalități', group: 'Corecție și penalități' },
  FWA: { label: 'Anulare penalități', group: 'Corecție și penalități' },
  // eMAG Genius
  FET: { label: 'Genius — taxă administrativă', group: 'eMAG Genius' },
  FETA: { label: 'Anulare taxă administrativă Genius', group: 'eMAG Genius' },
  FETS: { label: 'Storno taxă administrativă Genius', group: 'eMAG Genius' },
  FETSA: { label: 'Anulare storno taxă administrativă Genius', group: 'eMAG Genius' },
  FHDR: { label: 'Genius — despăgubire retur', group: 'eMAG Genius' },
  FHDRA: { label: 'Anulare despăgubire retur Genius', group: 'eMAG Genius' },
  FED: { label: 'Comision Genius (2 RON/comandă)', group: 'eMAG Genius' },
  FEDA: { label: 'Anulare comision Genius', group: 'eMAG Genius' },
  // eMAG ADS
  FAPO: { label: 'Ads post-paid', group: 'eMAG ADS' },
  FACCP: { label: 'Ads clickuri pre-paid', group: 'eMAG ADS' },
  FAPOF: { label: 'Ads credit gratuit', group: 'eMAG ADS' },
  FAPC: { label: 'Discount credit gratuit Ads', group: 'eMAG ADS' },
  FAACP: { label: 'Avans credit pre-paid Ads', group: 'eMAG ADS' },
  FAECP: { label: 'Credit pre-paid expirat Ads', group: 'eMAG ADS' },
  FASCPA: { label: 'Storno avans credit pre-paid Ads', group: 'eMAG ADS' },
  // Transport
  FIT: { label: 'Taxă servicii logistice', group: 'Transport' },
  // eMAG Courier
  FHIC: { label: 'Despăgubire eMAG Courier', group: 'eMAG Courier' },
  FHICM: { label: 'Despăgubire parțială eMAG Courier', group: 'eMAG Courier' },
  FHICMA: { label: 'Anulare despăgubire parțială eMAG Courier', group: 'eMAG Courier' },
}

/** Cost real de ads (intră în cheltuieli): post-paid + clickuri pre-paid consumate. */
export const ADS_COST_CODES = new Set(['FAPO', 'FACCP'])

/** Credite/avansuri ads — NU sunt cost (creditul gratuit + stornările/avansurile se anulează). */
export const ADS_CREDIT_CODES = new Set(['FAPOF', 'FAPC', 'FAACP', 'FAECP', 'FASCPA'])

/** Denumire prietenoasă pentru un cod de tip factură; fallback = numele brut eMAG sau codul. */
export function invoiceTypeLabel(code: string, fallback?: string): string {
  return EMAG_INVOICE_TYPES[code]?.label ?? fallback ?? code
}
